import { io, Socket } from 'socket.io-client'
import { AppNotification, SocialTrackerStatus } from '@digital-twins/shared-types'

export interface SocialTrackerUpdatedMessage {
  trackerToken: string
  status: SocialTrackerStatus
}

let notifSocket: Socket | null = null

export function connectNotificationsSocket(): Socket {
  if (!notifSocket) {
    const baseUrl =
      typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : ''

    notifSocket = io(`${baseUrl}/notifications`, {
      transports: ['websocket', 'polling'],
      path: '/api/socket.io/',
      autoConnect: true,
      withCredentials: true,
    })

    notifSocket.on('connect', () => {
      console.log('[NotificationsSocket] connected, id:', notifSocket?.id)
    })

    notifSocket.on('disconnect', (reason) => {
      console.warn('[NotificationsSocket] disconnected:', reason)
    })

    notifSocket.on('connect_error', (error) => {
      console.error('[NotificationsSocket] connect_error:', error.message)
    })
  }

  if (!notifSocket.connected) {
    notifSocket.connect()
  }

  return notifSocket
}

export function disconnectNotificationsSocket(): void {
  if (notifSocket) {
    notifSocket.disconnect()
    notifSocket = null
  }
}

export function onNotificationNew(
  callback: (notification: AppNotification) => void,
): () => void {
  const ws = connectNotificationsSocket()
  ws.on('notification.new', callback)
  return () => {
    ws.off('notification.new', callback)
  }
}

/** Invalidate pending artifact receipts; the event carries no lifecycle state. */
export function onArtifactAttentionChanged(callback: () => void): () => void {
  const ws = connectNotificationsSocket()
  ws.on('notification.attention.changed', callback)
  return () => ws.off('notification.attention.changed', callback)
}

/** A sync moved one of the org's trackers to a new status. */
export function onSocialTrackerUpdated(
  callback: (message: SocialTrackerUpdatedMessage) => void,
): () => void {
  const ws = connectNotificationsSocket()
  ws.on('social.tracker.updated', callback)
  return () => {
    ws.off('social.tracker.updated', callback)
  }
}
